import { IDonor, IMatchRunPosition, ISwapFailureAnalysis } from '@nkr/models/index';
import { renderCenter } from './center-with-swap-failures';
import PopoverTemplate from '@nkr/components/popover-template';
import { SsdTableWrapper } from './styles';
import { Glyphicon, OverlayTrigger } from 'react-bootstrap';
import React from 'react';

interface IProps {
    position: IMatchRunPosition,
    bridgeDonor: IDonor,
    swapFailure: ISwapFailureAnalysis,
    rowRef: any,
    onShowAcceptsData: (donor: IDonor, rowRef: any) => void,
}


const renderDonorInformation = (donor: IDonor) => {
    return (
        <PopoverTemplate width='1000px' dismiss={false}>
            <SsdTableWrapper condensed striped bordered>
                <thead>
                    <tr>
                        <th>FAnat</th>
                        <th>CC</th>
                        <th>EBV</th>
                        <th>CMV</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{getWhichKidney(donor)}</td>
                        <td>{donor.creatinineClearance}</td>
                        <td>{donor.ebv}</td>
                        <td>{donor.cmv}</td>
                    </tr>
                </tbody>
            </SsdTableWrapper>
        </PopoverTemplate>
    )
}

const getWhichKidney = (donor: IDonor) => {
    if (donor.whichKidney != '' && donor.whichKidney != 'DNK') {
        let results = `${donor.whichKidneyAbbreviated}${donor.numberOfArteries}`;

        if (donor.whichKidney == 'L-opt') {
            results += '(R)';
        }

        if (donor.whichKidney == 'R-opt') {
            results += '(L)';
        }

        return results;
    }

    return '--';
};


const BridgeDonorRow = (props: IProps) => {
    const { position, bridgeDonor } = props;

    const rdnCenterAlias = bridgeDonor.rdnCenter != null ? bridgeDonor.rdnCenter.alias : '';

    return (
        <tr>
            <td>{position.distance + 1}</td>
            <td>
                {renderCenter(bridgeDonor.center.alias, rdnCenterAlias, bridgeDonor.center.isAdpPartner, props.swapFailure)}
            </td>
            <td>
                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                    <OverlayTrigger placement='top' overlay={renderDonorInformation(bridgeDonor)}>
                        <a href={`/center/${bridgeDonor.center.id}/donor/${bridgeDonor.id}/profile`} target='_blank'>{bridgeDonor.alias}</a>
                    </OverlayTrigger>
                    {/* <Glyphicon
                        glyph='list-alt'
                        style={{ marginLeft: 3, padding: 0, lineHeight: 'initial' }}
                        onClick={() => props.onShowAcceptsData(bridgeDonor, props.rowRef.current)}
                    /> */}
                </div>
            </td>
            <td>--</td> {/* rec center */}
            <td>--</td> {/* rec alias */}
            <td>{bridgeDonor.bloodTypeDisplay}</td>
            <td>{bridgeDonor.age}:--</td>
            <td>--</td> {/*rec blood type */}
            <td>--</td> {/*donation type */}
            <td>--</td> {/*patient type */}
            <td>--</td> {/*clc */}
            <td>--</td> {/*cpra4 */}
            <td>--</td> {/*d/r */}
            <td>--</td> {/*epm */}
            <td>--</td> {/*hla */}
            <td>--</td> {/*sct */}
            <td>--</td> {/*wt */}
            <td>--</td>
            <td>--</td>
            <td>--</td>
        </tr>
    );
}

export default BridgeDonorRow;